import { render, staticRenderFns } from "./review-status.vue?vue&type=template&id=2d7f31e8&"
import script from "./review-status.vue?vue&type=script&lang=js&"
export * from "./review-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports